module.exports = __webpack_public_path__ + "media/images/landing/work-time-0ccc9e65395f51b0d246f85c5f12d66c.svg";